/**
 * Tutorial Video Data for Help Center
 * Organized by category with video IDs and titles
 */

var tutorialVideoData = {
  'phone-cases-general': [
    {
      id: 'tkYGRftYeaw',
      title: 'How to Use NFC in PITAKA iPhone 15 Series Cases: Verify Authenticity and Access PitaStudio'
    }
  ],
  'phone-cases-edge': [
    {
      id: 'Azub06MZA-w',
      title: 'PITAKA Spacer Installation Guide'
    },
    {
      id: 'gDZkkWjQ0ZA',
      title: 'How to Install PITAKA Ultra-Slim Case'
    },
    {
      id: 'xzM595Zi8Xc',
      title: 'Installing and Removing MagEZ Case 5 for Galaxy Z Fold 6'
    },
    {
      id: 'L89MCFkYdZM',
      title: 'Installing and Removing MagEZ Case 5 for Galaxy Z Flip 6'
    },
    {
      id: 'T3-R-WXaLP0',
      title: 'How to Install and Remove Galaxy S24 Ultra, S24 Plus, S24 Case from PITAKA'
    }
  ],
  'phone-cases-summa': [
    {
      id: '0MZrg4ec3tA',
      title: 'How to Install PITAKA Aramid UltraGuard Case'
    }
  ],
  'phone-cases-cairn': [
    {
      id: 'z-FbTsdYSZ8',
      title: 'How to Install PITAKA Aramid ProGuard Case'
    }
  ],
  'phone-cases-aaron': [
    {
      id: 'uWcmQOJmloU',
      title: 'How to Customize PinButton on Your S25 Ultra for Ultimate Convenience?'
    },
    {
      id: '__CU96SJqmQ',
      title: 'How to set up PinButton correctly to make using your S24 Ultra easier？'
    }
  ],
  'phone-gears-carmounts': [
    {
      id: 'fv61zptmZ3g',
      title: 'How to Set Up NFC Tags with iPhone and PITAKA MagEZ Car Mount Pro2 Qi2?'
    }
  ],
  'phone-gears-grip': [
    {
      id: '9ReJ1_ypu3w',
      title: 'Wrong Way To Use Your PITAKA Case and PITAKA Grip'
    }
  ],
  'phone-gears-straps': [
    {
      id: '_3H5YHta3Cg',
      title: '1 to 3 Phone Strap User Guide'
    }
  ],
  'tablet-air-case': [
    {
      id: 'C5LD2lQGLbw',
      title: 'How to Install PITAKA Air Case for iPad Pro Series'
    }
  ],
  'tablet-charging-cases': [
    {
      id: 'EGm9t0nfQTk',
      title: 'Keep your iPad Pro charge easily!'
    }
  ],
  'tablet-folio2': [
    {
      id: 'isep7W7eyEk',
      title: 'Stand your iPad in four different angles!'
    }
  ],
  'tablet-ipad-stand': [
    {
      id: 'vKM8bHgkwWU',
      title: 'How to Install & Remove the MagEZ Charging Stand for Tablets'
    }
  ],
  'watch-bands': [
    {
      id: 'J-tNk48PiWE',
      title: 'Installing and Removing PITAKA Apple Watch Band Links'
    },
    {
      id: '_Rin_r6aSeE',
      title: 'How to change the Apple Watch band clasp'
    },
    {
      id: 'GNk05SAGoZU',
      title: 'How to Remove and Link Carbon Fiber Watch Band Module (Retro)'
    }
  ]
};

// Category name mapping
var categoryNames = {
  'phone-cases': 'Phone Cases',
  'phone-cases-general': 'Phone Cases - General Questions',
  'phone-cases-edge': 'Phone Cases - Edge Case',
  'phone-cases-summa': 'Phone Cases - Summa Case',
  'phone-cases-cairn': 'Phone Cases - Cairn Case',
  'phone-cases-pinbutton': 'Phone Cases - Aaron Case',
  'phone-gears': 'Phone Gears',
  'phone-gears-wallets': 'Phone Gears - Card Wallets',
  'phone-gears-powerbanks': 'Phone Gears - Power Banks',
  'phone-gears-carmounts': 'Phone Gears - Car Mounts',
  'phone-gears-grip': 'Phone Gears - MagEZ Grip',
  'phone-gears-straps': 'Phone Gears - Phone Straps',
  'tablet-cases': 'Tablet Cases',
  'tablet-air-case': 'Tablet Cases - Air Case',
  'tablet-aramid-woven': 'Tablet Cases - MagEZ Case 2',
  'tablet-charging-cases': 'Tablet Cases - Aramid Woven Charging Cases',
  'tablet-folio2': 'Tablet Cases - Folio 2',
  'tablet-ipad-stand': 'Tablet Cases - iPad Stand',
  'watch-airpods': 'Watch&Airpods Gears',
  'watch-bands': 'Watch&Airpods Gears - Carbon Fiber Watch Bands',
  'watch-aramid-cases': 'Watch&Airpods Gears - Aramid Woven Cases',
  'airpods-cases': 'Watch&Airpods Gears - AirPods Cases',
  // 'shipping': 'Shipping',
  // 'order': 'Order',
  // 'refund-return': 'Refund & Return'
};
